module.exports = __webpack_public_path__ + "img/twitter_sample_icon.3a518a98.svg";